















































































































































































































































































































































































































































































































































































































































































































































import { defineComponent, reactive, ref } from '@vue/composition-api';
import { Message } from 'element-ui';

import svgCom from '@components/Svg/index';
import request from '@utils/request';
import _Const from '@/Const';

export default defineComponent({
  name: 'PortalPage',
  components: {
    svgCom,
  },
  setup() {
    const isSpecialOffer = new Date() <= new Date(2025, 0, 1);
    const isSpecialOfferByCMB = new Date() <= new Date(2025, 0, 1);
    const creditIntroTab = ref(0);
    const platInfo = [
      { introText: '多银行入驻支持', imgName: 'index_plat_one' },
      { introText: '数据安全私密可信', imgName: 'index_plat_two' },
      { introText: '用户操作便利快捷', imgName: 'index_plat_three' },
      { introText: '付款流程节点可查', imgName: 'index_plat_four' },
      { introText: '融资流程透明可控', imgName: 'index_plat_five' },
      { introText: '加快资金回笼变现', imgName: 'index_plat_six' },
    ];
    const moreInfo = [
      { introText: '注册成为腾讯的供应商', svgName: 'index_more_one' },
      {
        introText: '与腾讯合作银行开通供应链融资功能',
        svgName: 'index_more_two',
      },
      {
        introText: '收到<b>供应链协同平台</b>邀请邮件',
        svgName: 'index_more_three',
      },
      {
        introText: '注册登录<b>供应链协同平台</b>',
        svgName: 'index_more_four',
      },
      {
        introText: '选择付款单（全专票）提交融资申请',
        svgName: 'index_more_five',
      },
      { introText: '银行审批放款', svgName: 'index_more_six' },
    ];

    const moreInfoFinancing = [
      {
        introText: '注册<b>供应链协同平台</b>，<br/>获取供应商评分',
        svgName: 'index_more_one',
      },
      {
        introText: '选择合作银行，在线评估',
        svgName: 'index_more_two',
      },
      {
        introText: '评估通过，点击前往银行服务端<br/>开通服务、核额审批',
        svgName: 'index_more_three',
      },
      {
        introText: '审批通过',
        svgName: 'index_more_four',
      },
      {
        introText: '按需求选择融资',
        svgName: 'index_more_five',
      },
    ];
    const checkList = reactive({
      checkedOne: false,
      checkedTwo: false,
    });
    const dialogBankVisible = ref(false);
    const toRegister = ref(false);
    const bankUrl = ref('');
    const navType = 1;

    // 投票提交
    const voteSubmit = async () => {
      let desire = '';
      if (checkList.checkedOne && checkList.checkedTwo) {
        desire = '1,2';
      } else {
        desire = checkList.checkedOne ? '1' : '2';
      }
      const res = await request('login', 'saveUserDesire', {
        ipAddress: null,
        desire,
      });
      if (res.code === 2000) {
        Message.success('提交成功，感谢您的反馈！');
      }
    };

    // 弹框确认跳转到问卷或银行指引页
    const toGuide = (toRegister) => {
      // const {href} = root.$router.resolve({path});
      dialogBankVisible.value = false;
      setTimeout(() => {
        if (toRegister) {
          window.open('https://wj.qq.com/s2/11867569/0801', '_blank');
        } else {
          window.open(bankUrl.value, '_blank');
        }
      }, 100);
    };

    // 模板下载
    const onDownload = async (type) => {
      if (type === 'operate') {
        await request('login', 'downLoadFile', {
          fileName: 'PLATFORM_OPERATION_MANUAL',
        });
      } else if (type === 'question') {
        await request('login', 'downLoadFile', {
          fileName: 'QUESTION_AND_ANSWER',
        });
      }
    };

    const toPdf = () => {
      window.open('/pdf?fileName=DATA_FIN_MANUAL', '_blank');
    };

    return {
      platInfo,
      moreInfo,
      checkList,
      navType,
      voteSubmit,
      toGuide,
      dialogBankVisible,
      bankUrl,
      toRegister,
      onDownload,
      _Const,
      creditIntroTab,
      toPdf,
      moreInfoFinancing,
      isSpecialOffer,
      isSpecialOfferByCMB,
    };
  },
});
